import { useState } from "react";
import { Apis } from "../../../lib/Apis";

export const useCategory = () => {
  const [loading, setLoading] = useState(false);

  const addCategory = async (categoryData) => {
    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("name", categoryData.name);
      formData.append("status", categoryData.status);

      if (categoryData.image) {
        formData.append("image", categoryData.image);
      }

      const response = await Apis.addCategory(formData);
      if (response?.status === 201) {
        return response.data;
      } else {
        throw new Error(response?.data?.message || "Failed to add category.");
      }
    } catch (error) {
      throw new Error(error.message || "Error adding category.");
    } finally {
      setLoading(false);
    }
  };
  const editCategory = async (id, categoryData) => {
    try {
      const formData = new FormData();
      formData.append("name", categoryData.name);
      formData.append("status", categoryData.status);

      if (categoryData.image instanceof File) {
        formData.append("image", categoryData.image);
      }

      for (const [key, value] of formData.entries()) {
      }


      const response = await Apis.updateCategoryData(id, formData);
      if (response?.status === 200) {
        return response.data;
      } else {
        throw new Error(response?.data?.message || "Failed to edit category.");
      }
    } catch (error) {
      throw new Error(error.message || "Error editing category.");
    }
  };
  const getCategories = async (setCategories) => {
    setLoading(true);
    try {
      const response = await Apis.getCategories();
      if (response?.status === 200) {
        setCategories(response.data.categories);
        return response;
      } else {
        throw new Error(response?.data?.message || "Failed to fetch categories.");
      }
    } catch (error) {
      alert(error.message || "Error fetching categories.");
    } finally {
      setLoading(false);
    }
  };

  const getCategoriesWithPagination = async (setCategories, setTotal, offset = 0, limit = 10, categoryName = "", status = "") => {
    setLoading(true);
    try {
      const params = {};

      if (categoryName) {
        params.categoryName = categoryName;
      }

      if (status !== "") {
        params.status = status === "true" ? true : false;
      }

      const response = await Apis.getCategoriesWithPagination(offset, limit, params);

      if (response?.status === 200) {
        setCategories(response.data.categories);
        const totalRecords = response.data.pagination?.totalRecords || response.data.categories.length;
        setTotal(totalRecords);
        return response;
      } else {
        throw new Error(response?.data?.message || "Failed to fetch categories.");
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
      throw new Error(error.message || "Error fetching categories.");
    } finally {
      setLoading(false);
    }
  };

  const searchCategories = async (categoryName, status, offset = 0, limit = 10) => {
    try {
      const params = {};

      if (categoryName) {
        params.categoryName = categoryName;
      }

      if (status !== "") {
        params.status = status === "true" ? true : false;
      }

      const response = await Apis.getCategoriesWithPagination(offset, limit, params);
      return response.data;
    } catch (error) {
      console.error("🚀 ~ file: useHook.js ~ line 64 ~ searchCategories ~ error", error);
      return error;
    }
  };

  const updateCategoryStatus = async (id, status) => {
    try {
      setLoading(true);
      const data = { id, status };
      const response = await Apis.updateCategoryStatus(id, data);
      if (response?.status === 200) {
        return response.data;
      } else {
        throw new Error(response?.data?.message || "Failed to update category status.");
      }
    } catch (error) {
      throw new Error(error.message || "Error updating category status.");
    } finally {
      setLoading(false);
    }
  };

  const deleteCategory = async (id) => {
    try {
      setLoading(true);
      const response = await Apis.deleteCategory(id);
      return response.data;
    } catch (error) {
      throw new Error(error.message || "Error deleting category.");
    } finally {
      setLoading(false);
    }
  };

  const updateCategoryPosition = async (categoryId, newPosition) => {
    try {
      const response = await Apis.updateCategoryPosition({ categoryId, newPosition });
      return response?.data;
    } catch (error) {
      console.error("Error updating category position:", error);
      throw error;
    }
  };

  return {
    addCategory,
    editCategory,
    loading,
    getCategories,
    getCategoriesWithPagination,
    updateCategoryStatus,
    searchCategories,
    deleteCategory,
    updateCategoryPosition
  };
};
